"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tablet = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Tablet = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "tablet", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ id: "tablet", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M6 3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v26a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3Zm2 24h16V5H8v22Zm7.5 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z", fill: "#909AB5", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M24 27V5L8 27h16Z", fill: "#909AB5", opacity: ".3" })] })) })));
};
exports.Tablet = Tablet;
